export default __webpack_public_path__ + "question-circle.svg";